import React from 'react';
import EmptyStateBasic from 'shared/components/EmptyStateBasic';
import {
	PageSection,
  PageSectionVariants,
  Badge,
  Bullseye,
  Spinner,
  Content,
  ContentVariants,
  Tooltip,
  Panel, PanelMain, PanelMainBody,
  Flex, FlexItem
} from '@patternfly/react-core';
import { Table /* data-codemods */, Caption, Tr, Tbody, Td, Th, Thead } from '@patternfly/react-table';
import { DiLinux } from "react-icons/di";
import { DiWindows } from "react-icons/di";
import { FaPhp } from "react-icons/fa6";
import { DiJsBadge } from "react-icons/di";
import { FaDesktop } from "react-icons/fa6";
import { FaServer } from "react-icons/fa6";
import { FaPrint } from "react-icons/fa6";


class PracticeStatistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadedPracticeStats: false,
      pracitice_stats_data: [],
    }
    this.Icon = {
      "LinuxIcon": <DiLinux size={18} style={{marginBottom: "-5px", marginRight: '5px'}} />,
      "WindowsIcon": <DiWindows size={20} style={{marginBottom: "-5px", marginRight: '5px'}} />,
      "ServerIcon": <FaServer size={18} style={{marginBottom: "-5px", marginRight: '5px'}} />,
      "DesktopIcon": <FaDesktop size={18} style={{marginBottom: "-5px", marginRight: '5px'}} />,
      "PhpIcon": <FaPhp size={25} style={{marginBottom: "-7px", marginRight: '5px'}} />,
      "JsIcon": <DiJsBadge size={20} style={{marginBottom: "-3px",  marginRight: '5px'}} />,
      "PrinterIcon": <FaPrint size={18} style={{marginRight: '5px'}} />
    };
  }
  
  GetPracticeStats = async (args) => {
    fetch(`${this.props.state.api_url}/ti/api/v1${args}`, {
        'method': 'GET',
      }
    )
    .then(resp => resp.json())
    .then(resp => this.setState({ 
      pracitice_stats_data: resp, 
      isLoadedPracticeStats: true
    }))
    .catch(err => this.setState({ error: err, isLoadedPracticeStats: false }));
  }
  componentDidMount() {
    this.props.state.activeItem = window.location.pathname;
    this.setState({isLoadedPracticeStats: false});
		this.GetPracticeStats(window.location.pathname);
	}
  
  componentDidUpdate(newProps, prevProps) {
    prevProps.location = window.location.pathname
    if (newProps.state.location !== prevProps.location) {
      if(this.GetPracticeStats(window.location.pathname)) {
        prevProps.location = window.location.pathname
        newProps.state.location = window.location.pathname
      }
    }
  }

  dev_types_stats(data) {
    return (
      <React.Fragment>
        <Td>
          <>
            <Tooltip content={<div>{data.description}</div>}>
              {this.Icon[data.icon_name]}
            </Tooltip>
            { data.sheet_type.toUpperCase() } {' '}
          </>
        </Td>
        <Td>
          <Tooltip content={<div>{`Zrealizowane arkusze dla ${data.sheet_type.toUpperCase()} / Liczba arkuszy dla ${data.sheet_type.toUpperCase()}`}</div>}>
            <Badge isRead style={{width: '50px'}}>
              { data.completed }/{ data.total } {' '}
            </Badge>
          </Tooltip>
        </Td>
        <Td>
          {Math.floor( data.completed * 100 / data.total ) === 0 &&
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge className="pf-v5-global--palette--green-100" isRead style={{color: "red", width: '50px'}}>
                {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
          {Math.floor( data.completed * 100 / data.total ) >= 100 &&
            // <Badge className="pf-v5-global--palette--green-100" isRead style={{width: '50px', backgroundColor: '#eaf9e8'}} title={'Realizacja arkuszy procentowo dla '+data.sheet_type.toUpperCase()}>
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge className="pf-v5-global--palette--green-100" isRead style={{color: "green", width: '50px'}}>
                {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
          {Math.floor( data.completed * 100 / data.total ) > 0 && Math.floor( data.completed * 100 / data.total ) < 100 &&
            // {/* <Badge isRead style={{width: '50px'}} title={'Realizacja arkuszy procentowo dla '+data.sheet_type.toUpperCase()}> */}
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge isRead style={{width: '50px'}}>
                {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
        </Td>
      </React.Fragment>
    )
  }
  sys_types_stats(data) {
    return (
      <React.Fragment>
        <Td>
          <Tooltip content={<div>{data.description}</div>}>
            {this.Icon[data.brand_icon_name]}
          </Tooltip>
          <Tooltip content={<div>{data.os_type_description}</div>}>
            {this.Icon[data.os_type_icon]}
          </Tooltip>
        </Td>
        <Td>
          <Tooltip content={<div>{`Zrealizowane arkusze dla ${data.sheet_type.toUpperCase()} / Liczba arkuszy dla ${data.sheet_type.toUpperCase()}`}</div>}>
            <Badge isRead style={{width: '50px'}}>
              { data.completed }/{ data.total } {' '}
            </Badge>
          </Tooltip>
        </Td>
        <Td>
          {Math.floor( data.completed * 100 / data.total ) >= 100
            ? (
              <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
                <Badge className="pf-v5-global--palette--light-green-100" isRead style={{color: "green", width: '50px'}}>
                  {Math.floor( data.completed * 100 / data.total )}%
                </Badge>
              </Tooltip>
            )
            : (
              <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
                <Badge isRead style={{width: '50px'}}>
                  {Math.floor( data.completed * 100 / data.total )}%
                </Badge>
              </Tooltip>
            )
          }
        </Td>
      </React.Fragment>
    )
  }
  other_stats(data) {
    return (
      <React.Fragment>
        <Td>
          {data.icon_name === 'PrinterIcon'
            // ? <img style={{ height: '15px', marginBottom: '-3px' }} src={this.Icons[data.icon_name]} title={data.description} alt={data.description}></img>
            ? (
              <Tooltip content={<div>{data.description}</div>}>
                {this.Icon[data.icon_name]}
              </Tooltip>
            )
            : (
              <Tooltip content={<div>{data.description}</div>}>
                <span> { data.sheet_type.toUpperCase() } {' '}</span>
              </Tooltip>
            )
          }
        </Td>
        <Td>
          <Tooltip content={<div>{`Zrealizowane arkusze dla ${data.sheet_type.toUpperCase()} / Liczba arkuszy dla ${data.sheet_type.toUpperCase()}`}</div>}>
            <Badge isRead style={{width: '50px'}}>
              { data.completed }/{ data.total } {' '}
            </Badge>
          </Tooltip>
        </Td>
        <Td>
        
          {Math.floor( data.completed * 100 / data.total ) === 0 &&
            // <Badge className="pf-v5-global--palette--red-50" isRead style={{width: '50px', backgroundColor: '#f9e3e0'}} title={'Realizacja arkuszy procentowo dla '+data.sheet_type.toUpperCase()}>
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge className="pf-v5-global--palette--red-50" isRead style={{color: "red",  width: '50px'}}>
                  {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
          {Math.floor( data.completed * 100 / data.total ) >= 100 &&
            // <Badge isRead style={{width: '50px', backgroundColor: '#eaf9e8'}} title={'Realizacja arkuszy procentowo dla '+data.sheet_type.toUpperCase()}>
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge className="pf-v5-global--palette--light-green-100" isRead style={{color: "green",  width: '50px'}}>
                {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
          {Math.floor( data.completed * 100 / data.total ) > 0 && Math.floor( data.completed * 100 / data.total ) < 100 &&
            <Tooltip content={<div>{`Realizacja arkuszy procentowo dla ${data.sheet_type.toUpperCase()}`}</div>}>
              <Badge isRead style={{width: '50px'}}>
                {Math.floor( data.completed * 100 / data.total )}%
              </Badge>
            </Tooltip>
          }
        </Td>
      </React.Fragment>
    )
  }
  render() {
    if (this.state.isLoadedPracticeStats === true && Object.keys(this.state.pracitice_stats_data.stats).length === 0) {
      return (
        <React.Fragment>
          <EmptyStateBasic />
        </React.Fragment>
      )
    }
    if (this.state.isLoadedPracticeStats === false) {
      return (
        <React.Fragment>
            <Bullseye style={{ height: '100vh' }}>
              <Content style={{marginLeft: '10%', margin: 'auto'}}>
                <Content style={{textAlign: 'center'}} component={ContentVariants.h1}>Statystyki</Content>
                {this.state.isLoadedPracticeStats === false &&
                  <Bullseye><Spinner size="xl" aria-label="" /></Bullseye>
                }
              </Content>
            </Bullseye>
        </React.Fragment>
      )
    }
    if (this.state.isLoadedPracticeStats === true && Object.keys(this.state.pracitice_stats_data.stats).length > 0) {
      let execution_time = this.state.pracitice_stats_data.execution_time
      const { pracitice_stats_data } = this.state;
      let Obj = pracitice_stats_data.stats;
      return (
        <React.Fragment>
            <PageSection variant={PageSectionVariants.light}>
              <Flex direction={{ default: 'column' }}>
                {Object.entries(Obj).map(([group_symbol, item], i) => {
                  return (
                    <FlexItem key={i}>
                      <Panel variant="bordered">
                        <PanelMain>
                          <PanelMainBody>
                            {Object.entries(item).map(([group_name, e], j) => {
                              return (
                                <React.Fragment  key={j}>
                                  <b key={j}>{ group_symbol } - { group_name }</b>
                                  <br />
                                  <br />
                                  <Flex>
                                  {Object.entries(e.practice).map(([key, data], k) => {
                                    return (
                                      <FlexItem key={k}>
                                        <Panel variant="raised">
                                          <PanelMain>
                                            <PanelMainBody>
                                              <Table variant={'compact'}>
                                                <Caption>
                                                  <Tooltip content={<div>{ data.qualification_name }</div>}>
                                                    <Badge style={{width: '50px'}}>
                                                      { data.qualification_symbol }
                                                    </Badge>
                                                  </Tooltip>{' '}
                                                  <Tooltip content={<div>Zrealizowane arkusze / Całokowita liczba arkuszy</div>}>
                                                    <Badge isRead style={{width: '50px'}}>
                                                      { data.completed_for_group_qualification }/{ data.number_of_sheets }
                                                    </Badge>
                                                  </Tooltip>{' '}
                                                  {data.completed_percentage_for_group_qualification < 50 && data.exam.exam_year !== (data.exam.current_year+data.exam.threshold+1) &&
                                                    <Tooltip content={<div>Realizacja arkuszy procentowo</div>}>
                                                      <Badge isRead style={{width: '50px'}}>
                                                        {data.completed_percentage_for_group_qualification}%
                                                      </Badge>
                                                    </Tooltip>
                                                  }
                                                  {data.completed_percentage_for_group_qualification >= 50 && data.completed_percentage_for_group_qualification < 100 &&
                                                    <Tooltip content={<div>Realizacja arkuszy procentowo</div>}>
                                                      <Badge isRead style={{width: '50px'}}>
                                                        {data.completed_percentage_for_group_qualification}%
                                                      </Badge>
                                                    </Tooltip>
                                                  }
                                                  {/* {data.completed_percentage_for_group_qualification > 20 && data.completed_percentage_for_group_qualification < 50 && data.exam.exam_year === (data.exam.current_year+data.exam.threshold+1) &&
                                                    data.qualification_symbol !== 'E.12' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#EC7A08', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                      // <Badge isRead className="--pf-v5-global--success-color--100" style={{width: '50px'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol !== 'E.13' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#EC7A08', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol !== 'E.14' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#EC7A08', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                  } */}
                                                  {/* {data.completed_percentage_for_group_qualification <= 20 && data.exam.exam_year === (data.exam.current_year+data.exam.threshold+1) &&
                                                    data.qualification_symbol !== 'E.12' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#C9190B', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 20%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol !== 'E.13' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#C9190B', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 20%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol !== 'E.14' &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: '#C9190B', color: 'white'}} title="Realizacja arkuszy procentowo poniżej 20%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                  }
                                                  {data.qualification_symbol === 'E.12' &&
                                                      <Badge isRead style={{width: '50px'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol === 'E.13' &&
                                                      <Badge isRead style={{width: '50px'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                    && data.qualification_symbol === 'E.14' &&
                                                      <Badge isRead style={{width: '50px'}} title="Realizacja arkuszy procentowo poniżej 50%">{data.completed_percentage_for_group_qualification}%</Badge>
                                                  }
                                                  {data.completed_percentage_for_group_qualification >= 100 &&
                                                    <Badge isRead style={{width: '50px', backgroundColor: '#3E8635', color: 'white'}} title="Realizacja arkuszy procentowo">
                                                      {data.completed_percentage_for_group_qualification}% 
                                                    </Badge>
                                                  } */}
                                                  {/*
                                                  {data.completed_percentage_for_group_qualification < 50 && 
                                                    data.exam.exam_year === 2023 &&
                                                      <Badge isRead style={{width: '50px', backgroundColor: 'brown', color: 'white'}} title="Rok egzaminu zawodowego">{data.exam.exam_year}</Badge>
                                                  }
                                                  */}
                                                </Caption>
                                                {/*
                                                <Thead>
                                                  <Tr>
                                                    <Th>Technologia</Th>
                                                    <Th>Zrealizowane arkusze/Liczba arkuszy</Th>
                                                    <Th>Procentowo</Th>
                                                  </Tr>
                                                </Thead>
                                                */}
                                                <Tbody>
                                                  {data.hasOwnProperty('linux_server') && data.linux_server.total > 0 && (                                                  
                                                    <Tr>
                                                      {this.sys_types_stats(data.linux_server)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('windows_server') && data.windows_server.total > 0 && (
                                                    <Tr>
                                                      {this.sys_types_stats(data.windows_server)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('linux_desktop') && data.linux_desktop.total > 0 && (
                                                    <Tr>
                                                      {this.sys_types_stats(data.linux_desktop)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('windows_desktop') && data.windows_desktop.total > 0 && (
                                                    <Tr>
                                                      {this.sys_types_stats(data.windows_desktop)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('printer') && data.printer.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.printer)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('dhcp') && data.dhcp.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.dhcp)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('smb') && data.smb.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.smb)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('ssh') && data.ssh.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.ssh)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('routing') && data.routing.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.routing)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('ad') && data.ad.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.ad)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('ftp') && data.ftp.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.ftp)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('http') && data.http.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.http)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('apache') && data.apache.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.apache)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('iis') && data.iis.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.iis)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('dns') && data.dns.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.dns)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('mgmt') && data.mgmt.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.mgmt)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('rdp') && data.rdp.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.rdp)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('wifi') && data.wifi.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.wifi)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('php') && data.php.total > 0 && (
                                                    <Tr>
                                                      {this.dev_types_stats(data.php)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('js') && data.js.total > 0 && (
                                                    <Tr>
                                                      {this.dev_types_stats(data.js)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('sql') && data.sql.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.sql)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('gimp') && data.gimp.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.gimp)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('inkscape') && data.inkscape.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.inkscape)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('access') && data.access.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.access)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('ak') && data.ak.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.ak)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('am') && data.am.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.am)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('doc') && data.doc.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.doc)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('aw') && data.aw.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.aw)}
                                                    </Tr>
                                                  )}
                                                  {data.hasOwnProperty('test') && data.test.total > 0 && (
                                                    <Tr>
                                                      {this.other_stats(data.test)}
                                                    </Tr>
                                                  )}
                                                </Tbody>
                                              </Table>
                                              <br />
                                              <Table
                                                // style={{backgroundColor: '#F0F0F0', borderRadius: '10px', border: 'none'}}
                                                style={{borderRadius: '10px', border: 'none'}}
                                                aria-label="Simple table"
                                                variant={'compact'}
                                                borders={false}
                                              >
                                                {! group_symbol.includes("ABS") && data.qualification_symbol === 'INF.02' && data.exam.exam_year >= data.exam.current_year && data.exam.weeks_before_exam <= 53 &&
                                                  <Thead>
                                                    <Tr>
                                                        <Th colSpan={3}>Termin egzaminu</Th>
                                                    </Tr>
                                                  </Thead>
                                                }
                                                {! group_symbol.includes("ABS") && (data.qualification_symbol === 'INF.03' || data.qualification_symbol === 'EE.09' ) && data.exam.exam_year >= data.exam.current_year && data.exam.weeks_before_exam <= 53 &&
                                                  <Thead>
                                                    <Tr>
                                                        <Th colSpan={3}>Termin egzaminu</Th>
                                                    </Tr>
                                                  </Thead>
                                                }
                                                <Tbody>
                                                {! group_symbol.includes("ABS") && data.qualification_symbol === 'INF.02' && data.exam.exam_year >= data.exam.current_year && data.exam.weeks_before_exam <= 53
                                                    ? (
                                                      <Tr>
                                                        <Td>{data.exam.exam_month}</Td>
                                                        <Td>{data.exam.exam_year}</Td>
                                                        <Td>
                                                          <Tooltip content={<div>{`Do egzaminu około ${data.exam.weeks_before_exam} tygodni`}</div>}>
                                                            <span>{data.exam.weeks_before_exam} tyg.</span>
                                                          </Tooltip>
                                                        </Td>
                                                      </Tr>
                                                    )
                                                    : ''
                                                  }
                                                  {! group_symbol.includes("ABS") && (data.qualification_symbol === 'INF.03' || data.qualification_symbol === 'EE.09' ) && data.exam.exam_year >= data.exam.current_year && data.exam.weeks_before_exam <= 53
                                                    ? (
                                                      <Tr>
                                                        <Td>{data.exam.exam_month}ń</Td>
                                                        <Td>{data.exam.exam_year}</Td>
                                                        <Td>
                                                          <Tooltip content={<div>{`Do egzaminu około ${data.exam.weeks_before_exam} tygodni`}</div>}>
                                                            <span> {data.exam.weeks_before_exam} tyg. </span>
                                                          </Tooltip>
                                                        </Td>
                                                      </Tr>
                                                    )
                                                    : ''
                                                  }
                                                </Tbody>
                                              </Table>
                                            </PanelMainBody>
                                          </PanelMain>
                                        </Panel>  
                                      </FlexItem>
                                    )
                                  })}
                                  </Flex>
                                </React.Fragment>
                              )
                            })}
                          </PanelMainBody>
                        </PanelMain>
                      </Panel>
                    </FlexItem>
                  ) 
                })}
              </Flex>
            </PageSection>
        </React.Fragment>
      )
    }
  }
}
export default PracticeStatistics;
